import { forwardRef } from "react"
import { useScreenSize } from "../hooks/useScreenSize"

const Container = forwardRef((props: any = {}, ref: any) => {
  const { screenLargerThan } = useScreenSize();
  const isLarge = screenLargerThan('lg');
  const isSmall = screenLargerThan('sm');

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        gap: '10px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'var(--color-neutral)',
        color: 'var(--color-base-300)',
        padding: isLarge ? '20px 100px' : isSmall ? '20px 40px' : '20px 16px',
        ...props.style
      }}
      ref={ref}
      className={props.className}
    >
      {props.children}
    </div>
  )
})

function HeaderDescription({ children }: any) {
  return (
    <p>
      {children}
    </p>
  )
}

function Header({ children }: any) {
  return (
    <h1 className="text-3xl sm:text-4xl font-bold">
      {children}
    </h1>
  )
}

const Content = forwardRef((props: any = {}, ref: any) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '10px',
        justifyContent: 'center',
        width: '100%',
        ...props.style
      }}
      ref={ref}
    >
      {props.children}
    </div>
  )
})

export const HomeSectionLayout = {
  Container,
  Header,
  HeaderDescription,
  Content
}
